import { Navbar, Nav, NavDropdown } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

function Header({ profileState }) {
    const { authenticated, projectRole } = profileState;
    const pName = projectRole?.projectName;
    const role = projectRole?.role;
    const navigate = useNavigate()
    const handleNavigate = (path) => () => navigate(path)

    return (
        <header>
            <Navbar className="navbar navbar-dark  navbar-expand-xl bg-primary" style={{ height: "46.5px" }} fixed="top" >
                <Nav className="w-100">
                    <Nav.Link onClick={handleNavigate("/")}>Mon projet {pName && `(${pName})`}</Nav.Link>
                    <Nav.Link onClick={handleNavigate("/projects/")}>Changer de projet</Nav.Link>
                    <Nav.Link onClick={handleNavigate("/account/")}>Mon compte</Nav.Link>
                    {
                        (role && (role > 0)) ?
                            <NavDropdown title="Traitement" id="nav-dropdown">
                                <NavDropdown.Item eventKey="0.0" onClick={handleNavigate("/tasks/")}>Statut des tâches</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item eventKey="0.1" onClick={handleNavigate("/export/")}>Export</NavDropdown.Item>
                                {
                                    (role && (role > 1)) && <>
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item eventKey="1.0" onClick={handleNavigate("/fusion/")}>Fusion</NavDropdown.Item>
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item eventKey="1.2" onClick={handleNavigate("/filtre/")}>Filtre</NavDropdown.Item>
                                        <NavDropdown.Divider />
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item eventKey="1.1" onClick={handleNavigate("/import/yatea/")}>Import YaTea </NavDropdown.Item>
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item eventKey="2.1" onClick={handleNavigate("/import/termsuite/")}>Import TermSuite</NavDropdown.Item>
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item eventKey="2.2" onClick={handleNavigate("/import/skos/")}>Import SKOS</NavDropdown.Item>
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item eventKey="3.1" onClick={handleNavigate("/import/listeplate/")}>Import Liste plate</NavDropdown.Item>
                                        <NavDropdown.Divider />
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item eventKey="4.0" onClick={handleNavigate("/import/docs/")}>Importer un corpus et extraire des termes</NavDropdown.Item>
                                    </>
                                }

                            </NavDropdown> : <></>
                    }

                    {
                        authenticated
                            ? <Nav.Link className="ml-auto " onClick={handleNavigate("/logout/")}>Déconnexion</Nav.Link>
                            : <Nav.Link className="ml-auto " onClick={handleNavigate("/account/")}>Connexion</Nav.Link>
                    }
                </Nav>
            </Navbar>
        </header>
    )
}

export default Header
